import React, {createRef} from "react"

import FinderHeader from '../header/finder-header'
import NoteFinderMain from "./note-finder-main"
import ApiFinder from "../../../gd/api/finder"
import asyncSessionLoader from "../../../gd/data/async-session-loader"

// @ts-ignore
import { when } from "simply-deferred"

const MIN_SEARCH_TEXT_LENGTH = 2

type Props = {
    className?          : string

    parentProjectId?    : ID

    noHeader            : boolean

    onClickNote         : func
    onClose?            : func
    onTab               : func
}

export default class NoteFinder extends React.Component<Props, any> {

    private finderRef: any = createRef()
    private delayedNotesSearch: any

    constructor(props: Props) {
        super(props)

        this.state = {
            search          : '',
            isSearching     : false,

            parentProjectId : props.parentProjectId ? props.parentProjectId : null,
            data            : null
        }

        this.delayedNotesSearch = _.debounce(this.notesSearch, 500)
    }

    componentDidMount() {
        this.loadData()
    }

    componentWillUnmount() {
        this.delayedNotesSearch.cancel();
    }

    loadData = () => {
        if (!this.state.parentProjectId) {
            this.setState({
                data: []
            })
            return
        }

        when(gd.session.noteTypes).then(
            async ()=>{
                const response = await ApiFinder.notes(this.state.parentProjectId).promise()
                let loadedData: any[] = []

                await asyncSessionLoader(this.findMissingData(response))

                _.map(response, n=>{
                    loadedData.push({
                        noteType    : gd.session.noteTypes.get(n.noteTypeId),
                        id          : n.id,
                        name        : n.name,
                        projectId   : this.state.parentProjectId
                    })
                })

                this.setState({
                    data: loadedData
                })
            }
        )
    }

    findMissingData(data: any) {
        if (!data) return false

        const allProjects = _.uniq(_.map(data, 'projectId'))
        let allUsers: ID[] = []
        _.map(data, i=>{
            allUsers = _.union(allUsers,i.users)
        })
        allUsers = _.uniq(allUsers)
        const allNoteTypes = _.uniq(_.map(data, 'noteTypeId'))

        return gd.session.findMissing({
            projects    : allProjects,
            users       : allUsers,
            noteTypes   : allNoteTypes
        })
    }

    clearData = () => {
        this.setState({
            data: null
        })
    }

    onSearchChange = (value: any) => {
        const isSearching = value.length >= MIN_SEARCH_TEXT_LENGTH;
        if (this.state.search && !value) {
            this.onSearchCancel();
        } else {
            this.setState({
                search: value,
                isSearching: isSearching,
                data: null
            }, ()=>{
                if (isSearching) this.delayedNotesSearch();
            })
        }
    }

    onSearchCancel = () => {
        this.clearData()
        this.setState({
            isSearching : false,
            search      : '',
            data        : null
        }, ()=>{
            this.loadData()
        })
    }

    notesSearch = async () => {
        if (!this.state.search) {
            this.onSearchCancel()
            return false
        } else if (this.state.search.length < MIN_SEARCH_TEXT_LENGTH) {
            return false
        }

        try {
            const response = await gd.api.Search.notes(this.state.search).promise()

            this.setState({
                isSearching : false,
                data        : _.orderBy(response.result, n=>n.name.toLowerCase())
            });
        } catch (e: any) {
            this.setState({
                isSearching : false,
                data        : []
            });
        }
    }

    onClickNote = (note: any) => {if (this.props.onClickNote) this.props.onClickNote(note)}
    onTab = () => {this.props.onTab && this.props.onTab()}

    onClickCompany = () => {
        this.setState({
            parentProjectId: null,
            data: null
        }, ()=>{
            this.loadData();
        });
    }

    onClickProject = (id: ID) => {
        this.setState({
            parentProjectId: id,
            data: null
        }, ()=>{
            this.loadData();
        });
    }

    onClose = () => {
        if(this.props.onClose) this.props.onClose();
    }

    onKeyDown = (event: any) => {
        this.finderRef.current.onKeyDown(event)
    }

    render() {
        const classes = Classes("gd-finder", this.props.className, {
            'no-header': this.props.noHeader
        })

        return (
            <div className={classes}>
                {!this.props.noHeader &&
                    <FinderHeader title             = "Select a note"
                                  inputPlaceholder  = "Note name"
                                  search            = {this.state.search}
                                  onSearchChange    = {this.onSearchChange}
                                  onSearchCancel    = {this.onSearchCancel}
                                  onClose           = {this.onClose}/>}

                <NoteFinderMain ref             = {this.finderRef}
                                data            = {this.state.data}
                                isSearching     = {this.state.isSearching}
                                parentProjectId = {this.state.parentProjectId}
                                search          = {this.state.search}
                                onClickCompany  = {this.onClickCompany}
                                onClickProject  = {this.onClickProject}
                                onClickNote     = {this.onClickNote}
                                onTab           = {this.onTab}/>
            </div>
        )
    }
}